import React from "react";
import { Question } from "../../types";
import {
  computeSjtScore,
  getSjtCorrectOrderIds,
  getSjtLetterByAnswerId,
} from "./sjtUtils";
import "./SjtOrderPanel.scss";

type SjtOrderPanelProps = {
  question: Question;
  selection: number[];
};

const LetterChip: React.FC<{
  letter: string;
  tone?: "neutral" | "correct" | "incorrect";
}> = ({ letter, tone = "neutral" }) => (
  <div className={`sjt-order-panel__chip sjt-order-panel__chip--${tone}`}>
    {letter}
  </div>
);

/** Post-submit summary for the right-hand explanation panel */
export const SjtOrderPanel: React.FC<SjtOrderPanelProps> = ({
  question,
  selection,
}) => {
  const letterById = getSjtLetterByAnswerId(question);
  const correctOrder = getSjtCorrectOrderIds(question) || [];
  const score = computeSjtScore(question, selection);
  const total = correctOrder.length || selection.length || 5;

  return (
    <div className="sjt-order-panel">
      <div className="sjt-order-panel__row">
        <div className="sjt-order-panel__label">Your order</div>
        <div className="sjt-order-panel__chips">
          {selection.map((id, idx) => {
            const isCorrect = correctOrder[idx] === id;
            return (
              <LetterChip
                key={`y-${id}`}
                letter={letterById[id] || "?"}
                tone={isCorrect ? "correct" : "incorrect"}
              />
            );
          })}
        </div>
      </div>

      <div className="sjt-order-panel__row">
        <div className="sjt-order-panel__label">Correct order</div>
        <div className="sjt-order-panel__chips">
          {correctOrder.map((id) => (
            <LetterChip
              key={`c-${id}`}
              letter={letterById[id] || "?"}
              tone="neutral"
            />
          ))}
        </div>
      </div>

      <div className="sjt-order-panel__score">
        Score: {score}/{total}
      </div>
    </div>
  );
};
